(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-image"] && !Shopify.designMode) return;
  try {
    
(function() {
  const container = document.getElementById("beforeAfterSection");
  const beforeSide = document.getElementById("beforeSide");
  const afterSide = document.getElementById("afterSide");
  const handle = document.getElementById("sliderHandle");
  const circle = document.getElementById("sliderCircle");

  let isDragging = false;

  function setPosition(x) {
    const rect = container.getBoundingClientRect();
    let offset = Math.max(0, Math.min(x - rect.left, rect.width));
    let percentage = offset / rect.width * 100;

    // Clip-path for before image
    beforeSide.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;

    // Clip-path for after image (inverse)
    afterSide.style.clipPath = `inset(0 0 0 ${percentage}%)`;

    // Move handle + circle
    handle.style.left = percentage + "%";
    circle.style.left = percentage + "%";
  }

  // Drag events
  function startDrag() { isDragging = true; }
  function stopDrag() { isDragging = false; }
  function onDrag(e) { if (!isDragging) return; setPosition(e.clientX || e.touches[0].clientX); }

  circle.addEventListener("mousedown", startDrag);
  circle.addEventListener("touchstart", startDrag);
  handle.addEventListener("mousedown", startDrag);
  handle.addEventListener("touchstart", startDrag);

  window.addEventListener("mouseup", stopDrag);
  window.addEventListener("touchend", stopDrag);

  window.addEventListener("mousemove", onDrag);
  window.addEventListener("touchmove", onDrag);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-tab"] && !Shopify.designMode) return;
  try {
    
function initFaqToggle(container) {
  var scope = container || document;
  var faqSections = scope.querySelectorAll(".faq-collapsible .faq-item .faq-question");

  // clear old listeners
  faqSections.forEach(function(question) {
    question.replaceWith(question.cloneNode(true));
  });

  // reselect after clone
  faqSections = scope.querySelectorAll(".faq-collapsible .faq-item .faq-question");

  faqSections.forEach(function(question) {
    question.addEventListener("click", function() {
      var parent = this.parentElement;
      parent.classList.toggle("active");
    });
  });
}

// ✅ Run on first load (live store + editor)
document.addEventListener("DOMContentLoaded", function() {
  initFaqToggle(document);
});

// ✅ Run again whenever Shopify reloads section OR you edit in Customize
document.addEventListener("shopify:section:load", function(e) {
  initFaqToggle(e.target);
});
document.addEventListener("shopify:section:select", function(e) {
  initFaqToggle(e.target);
});
document.addEventListener("shopify:block:select", function(e) {
  initFaqToggle(e.target);
});
document.addEventListener("shopify:block:deselect", function(e) {
  initFaqToggle(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
